module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/hero-title-img@2x.6252527.png";